import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { concatMap, map } from "rxjs/operators";
import { catchError, of } from "rxjs";
import { LoginService, NotificationService } from "@core/services";
import { logout, logoutSuccessful, logoutFailed, refreshFromToken } from "@core/store/actions";

@Injectable()
export class SessionEffects {
  refreshFromToken$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(refreshFromToken),
        map(() => this.loginService.updateSessionWithTokenInformationIfExists())
      );
    },
    { dispatch: false }
  );

  logout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(logout),
      concatMap(() =>
        this.loginService.logout().pipe(
          map(() => logoutSuccessful()),
          catchError((error) => of(logoutFailed({ error })))
        )
      )
    );
  });

  notifyLogoutSuccessful$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(logoutSuccessful),
        map(() =>
          this.notificationService.showTranslatedNotification(
            "notifications.logout_successful",
            "confirmation"
          )
        )
      );
    },
    { dispatch: false }
  );

  notifyLogoutFailed$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(logoutFailed),
        map((error) => {
          console.error("Logout failed:", error);
          return this.notificationService.showTranslatedNotification(
            "notifications.logout_failed",
            "warning"
          );
        })
      );
    },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private loginService: LoginService,
    private notificationService: NotificationService
  ) {}
}
